import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-ctrl-item-info",
  templateUrl: "./ctrl-item-info.component.html",
  styleUrls: ["./ctrl-item-info.component.css"],
})
export class CtrlItemInfoComponent implements OnInit {
  @Input() survey: any;
  @Input() item: any;
  @Output() itemChanged = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  public onRemoveSubindicator(subindicator: any) {
    if (confirm("Are you sure you want to delete this subindicator?") == true) {
      let index = this.item.subindicators.indexOf(subindicator);
      this.item.subindicators.splice(index, 1);
      this.itemChanged.emit({ item: this.item });
    }
  }

  public onChangeInfo() {
    this.itemChanged.emit({ item: this.item });
  }
}
